import * as Yup from 'yup';
import { isValidIBAN, electronicFormatIBAN } from 'ibantools';

export function generateSchema(resourcesOverview) {
  return Yup.object().shape({
    amount: Yup.string()
      .required('requests_form_required')
      .test(
        'requests_form_free_sources_amount_error',
        'requests_form_free_sources_amount_error',
        function(amount) {
          const virtual_account_type_id = this.parent.virtual_account_type_id;

          const exceededValue =
            Number(
              virtual_account_type_id === 1
                ? resourcesOverview.free_from_deposits
                : resourcesOverview.free_from_installments
            ) < Number(amount);

          return !exceededValue;
        }
      ),

    iban: Yup.string()
      .required('requests_form_required')
      .test(null, 'requests_form_bad_value', (inputValue) => {
        let iban = electronicFormatIBAN(inputValue);
        return isValidIBAN(iban);
      }),
    fee_schedule: Yup.bool().oneOf([true], 'requests_form_required'),
    provision_conflict: Yup.bool().oneOf([true], 'requests_form_required'),
  });
}
